<template>
  <div class="exam-paper exam-paper-content exam-detail">
    <div class="header">
      <div class="header-text">
        <div class="header-title">{{query.title}}</div>
        <div class="header-user">
          <img :src="userInfo.photo | imgFilter" alt="">
          参考人：{{userInfo.realname}}
        </div>
      </div>
    </div>

    <div class="content">
      <div class="content-left">
        <!-- 题型 -->
        <div v-for="(item, index) in subjectList" :key="index" v-if="subjectList && subjectList.length > 0 && subjectActive - 1 === index">
          <!-- 单选, 判断 -->
          <div v-if="item.subjectType === 0" class="exam-item exam-singel">
            <div class="head">
              <div class="head-title">单选题 <span>({{index + 1}}/{{subjectList.length}})</span></div>
              <div class="score">本题分数：{{item.score}}</div>
            </div>
            <div class="title">
              <span>{{index + 1}}、</span>
              <div v-html="item.title"></div>
            </div>
            <el-radio-group class="select" v-model="item.perAnswer">
              <el-radio disabled class="option" v-for="(items, indexs) in item.optionStandardAnswerPersonAnswerList" :key="indexs" :label="indexs + ''">{{letterList[indexs]}}、{{items.content}}</el-radio>
            </el-radio-group>
          </div>

          <!-- 多选 -->
          <div v-if="item.subjectType === 1" class="exam-item exam-double">
            <div class="head">
              <div class="head-title">多选题 <span>({{index + 1}}/{{subjectList.length}})</span></div>
              <div class="score">本题分数：{{item.score}}</div>
            </div>
            <div class="title">
              <span>{{index + 1}}、</span>
              <div v-html="item.title"></div>
            </div>
            <el-checkbox-group class="select" v-model="item.perAnswer">
              <el-checkbox disabled class="option" v-for="(items, indexs) in item.optionStandardAnswerPersonAnswerList" :key="indexs" :label="indexs + ''">{{letterList[indexs]}}、{{items.content}}</el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 问答 -->
          <div v-if="item.subjectType === 2" class="exam-item exam-qa">
            <div class="head">
              <div class="head-title">问答题 <span>({{index + 1}}/{{subjectList.length}})</span></div>
              <div class="score">本题分数：{{item.score}}</div>
            </div>
            <div class="title">
              <span>{{index + 1}}、</span>
              <div v-html="item.title"></div>
            </div>
            <el-input type="textarea" v-model="item.perAnswer" placeholder="请输入答案" class="input"></el-input>
            <div class="test-item-answer"  v-for="(fileitem, filteindex) in item.fileUrl"
                :key="filteindex">{{'图片：' }}
                <img id="imgId" :src="fileitem?fileitem:''" alt="图片" width="100" height="100" @click.self="showBigImage($event)"/>
            </div>
          </div>
        </div>

        <!-- 下一题 -->
        <div v-if="subjectList && subjectList.length > 0" class="btns-answer">
          <div class="ansewer">
            <!-- checkRule 1 显示得分 2 显示标准答案与得分 3 显示标准答案,得分,试题解析  -->
            <div v-if="(detail.checkRule === 2 || detail.checkRule === 3) && subjectList[subjectActive - 1].subjectType < 2" class="answer-ok">标准答案：{{subjectList[subjectActive - 1].answer}}</div>
            <div v-if="detail.checkRule === 3" class="answer-text">答案解析：{{subjectList[subjectActive - 1].subjectExplain}}</div>
            <div v-if="detail.checkRule === 1 || detail.checkRule === 2 || detail.checkRule === 3" class="answer-yes">本题得分：{{subjectList[subjectActive - 1].questionScore || '0'}}分</div>
          </div>

          <div class="btns">
            <div v-if="subjectActive < subjectList.length" class="btn" @click="handleNextExam">下一题</div>
          </div>
        </div>
      </div>

      <div class="content-right">
        <div v-if="detail && detail.examLevel < 4" class="head">
          <div class="count">
            考试成绩：<span class="count-num">{{detail.score}}分</span>
          </div>
          <div class="state" :class="detail.examLevel === 0 ? 'state-error' : ''">{{detail.examLevel === 0 ? '不合格' : detail.examLevel === 1 ? '及格' : detail.examLevel === 2 ? '良好' : detail.examLevel === 3 ? '优秀' : ''}}</div>
        </div>
        <div class="menu">
          <div class="menu-title">题目</div>
          <div class="menu-ul">
            <div class="menu-li" v-for="(item, index) in subjectList" :key="index" :class="item.resultType === 1 ? 'menu-li-yes' : item.resultType === 0 ? 'menu-li-no' : 'menu-li-part'" :style="subjectActive === index + 1 ? 'border-color:#3156C9;background-color:#fff;color:#3156C9;' : ''" @click="handleChangeSubject(index)">{{index + 1}}</div>
          </div>
          <div class="menu-btns">
            <div class="menu-btn" @click="handleBackStudy">退出查看</div>
          </div>
        </div>
      </div>
    </div>

    <Footerbar></Footerbar>
    <BigImg :visible="photoVisible" :url="bigImgUrl" @closeClick="()=>{photoVisible=false}"></BigImg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Footerbar from '../layout/components/Footerbar.vue'
import {setStorgeItem, getStorgeItem} from '@/utils/auth'
import BigImg from "./BigImg.vue";
export default{
  name: 'ExamPaperDetail',
  data() {
    return {
      query: {},
      detail: null,
      subjectList: [], // 考题
      subjectActive: 1, // 当前考题
      letterList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], // 字母表
      photoVisible: false,
      bigImgUrl: "",
    }
  },
  computed: {
    ...mapGetters([
  		'userInfo'
    ])
  },
  components: {
    Footerbar,
    BigImg
  },
  mounted() {
    this.query = {
      title: this.$route.query.title
    }
    this.subjectList = []
    this.subjectActive = 1
    this.handleGetExam()
  },
  methods: {
    // 放大图片
    showBigImage(e) {
      if (e != "") {
      this.photoVisible = true;
      this.bigImgUrl = e.currentTarget.src;
      }
    },
    // 考试
    handleGetExam() {
      this.$api.exam.examResultDetail({id: this.$route.query.id}).then(res => {
        this.changeDetail(res)
      })
    },
    changeDetail(res) {
        this.detail = res.data
        for(let item of res.data.subjectList){
          if(item.subjectType === 0){
            //单选
            let _answer = ''
            let _perAnswer = ''
            for(let i in item.optionStandardAnswerPersonAnswerList){
              let t = item.optionStandardAnswerPersonAnswerList[i]
              if(t.standardAnswer){
                _answer = this.letterList[i]
              }
              if(t.personAnswer){
                _perAnswer = i
              }
            }
            this.$set(item, 'answer', _answer)
            this.$set(item, 'perAnswer', _perAnswer)
          }
          if(item.subjectType === 1){
            //多选
            let _answer = []
            let _perAnswer = []
            for(let i in item.optionStandardAnswerPersonAnswerList){
              let t = item.optionStandardAnswerPersonAnswerList[i]
              if(t.standardAnswer){
                _answer.push(i)
              }
              if(t.personAnswer){
                _perAnswer.push(i)
              }
            }
            let __answer_str = ''
            _answer.map((item, index) => {
              let p = index === (_answer.length - 1) ? '' : '、'
              __answer_str += this.letterList[item] + p
            })
            this.$set(item, 'answer', __answer_str)
            this.$set(item, 'perAnswer', _perAnswer)
          }
          if(item.subjectType === 2){
            //问答
            this.$set(item, 'answer', item.content)
            this.$set(item, 'perAnswer', item.content)
          }
          this.$set(item, 'title', this.$util.removeHtml(item.title))
        }
        this.subjectList = res.data.subjectList
    },
    handleNextExam() {
      this.subjectActive++
    },
    handleChangeSubject(i) {
      this.subjectActive = i + 1
    },
    handleBackStudy() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/examPaper.scss';
    .test-item-answer {
        margin-bottom: .25rem;
        font-size: .13rem;
        color: $grey_font_color_80;
        line-height: .18rem;
    }
</style>
